import Vue from "vue"
import VueRouter from "vue-router"
import AnthemLinkHome from "../views/home.vue"
import AnthemLinkEvaluation from "../views/quiz.vue"

Vue.use(VueRouter)

const routes = [
  {
      path: "/",
      name: "Anthem Link Home",
      component: AnthemLinkHome,
      meta: {
            title: "Anthem Link Home"
      }
  },
  {
      path: "/evaluation",
      name: "Anthem Link Evaluation Quiz",
      component: AnthemLinkEvaluation,
      meta: {
            title: "Anthem Link Evaluation Quiz"
      }
  }
]

const router = new VueRouter({
      mode: "history",
      base: process.env.BASE_URL,
      routes
})
router.afterEach((to) => {
      if (to.meta && to.meta.title) {
            document.title = to.meta.title || "Anthem Link"
      }
})

export default router
